<template>
<div id="pageTable">
    <div class="page-header-left pa-3 pt-8" v-if="roleCustomer">
        <h4>Tài chính</h4>
    </div>
    <v-container grid-list-xl fluid v-if="roleCustomer">
        <v-card>
            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                <v-flex lg12 md12 sm12>
                    <div class="v-data-table v-data-table--has-bottom theme--light"><div class="v-data-table__wrapper">
                        <table>
                                <thead class="v-data-table-header">
                                <tr>
                                    <th scope='col'><span>Ngân hàng</span></th>
                                    <th scope='col'><span>Chủ tài khoản</span></th>
                                    <th scope='col'><span>Số tài khoản</span></th>
                                    <th scope='col'><span>Chi nhánh</span></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <th scope='row'>Techcombank</th>
                                    <td>Tuấn Anh</td>
                                    <td>999999999</td>
                                    <td>Hà Nội</td>
                                </tr>
                                <tr>
                                    <th scope='row'>MBBank</th>
                                    <td>Tuấn Anh</td>
                                    <td>999999999</td>
                                    <td>Nam Thăng Long</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <div class='text-center text--primary font-weight-bold'>
                        <span>Nội dung chuyển khoản: </span>
                        <span class='text-red'>{{ 'AH ' + staff.Username }}</span>
                    </div>
                </v-flex>
            </v-layout>
        </v-card>
    </v-container>
    <div class="page-header-left pa-3 pt-8" v-if="roleCustomer">
        <h4>Tài khoản</h4>
    </div>
    <v-container grid-list-xl fluid>
        <v-card>
            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                <v-flex lg12 md12 sm12>
                    <v-text-field v-model="staff.Username" ref="username" label="User Name" class="input-group--focused" disabled></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-text-field v-model="staff.PhoneNumber" label="Điện thoại" class="input-group--focused" disabled></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-text-field v-model="staff.FullName" label="Họ tên" class="input-group--focused" disabled></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-select v-model="staff.RoleID" :items="role_list" item-text="name" item-value="value" label="Quyền hạn" disabled class="input-group--focused"></v-select>
                </v-flex>                
                <v-flex lg12 md12 sm12>
                    <v-checkbox v-model="change_pass" label="Đổi mật khẩu" class="input-group--focused"></v-checkbox>
                </v-flex> 
                <v-flex lg12 md12 sm12>
                    <v-text-field v-model="password" type="password" label="Mật khẩu mới" :disabled="!change_pass" class="input-group--focused"></v-text-field>
                </v-flex>          
            </v-layout>
        </v-card>
    </v-container>
</div>
</template>

<script>
import { mapState } from "vuex";
import md5 from "md5";
import configs from "@/configs";
export default {
    data() {
        return {
            role_list: configs.ROLES,
            password: '',
            change_pass: false,
            bank_html: ''
        }
    },
    computed: {
        ...mapState({
            configuration: state => state.configuration.selected,
            loading: state => state.staff.loading,
            staff: state => state.staff.selected
        }),
        modifyId() {
            return this.$store.state.authentication.user.userid;
        },
        roleCustomer() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Customer;
        },
    },
    watch: {
        modifyId() {
            this.refreshData();
        },
        configuration() {
            this.bank_html = Buffer.from(this.configuration.Banks, 'base64').toString('utf-8');
        }
    },
    methods: {
        refreshData() {
            this.$store.dispatch("configuration/getDetail", 1);
            if (this.modifyId > 0) {
                this.$store.dispatch("staff/getDetail", this.modifyId);
            }
            this.$nextTick(() => this.$refs.username.focus());
        },
        saveData() {
            if(this.change_pass) {
                this.staff.Password = md5(this.password)
            }
            if(this.roleCustomer){
                this.staff = {
                    ID: this.staff.ID,
                    Password: this.staff.Password
                }
            }
            this.$store.dispatch("staff/setDetail", {
                data: this.staff,
                id: this.staff.ID,
                notify: 'Đã cập nhật tài khoản.'
            });
        },
    },
    mounted() {
        this.refreshData();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
        if (this.$route.query.uid && this.$route.query.uid !== '') {
            this.staff.UID = Number(this.$route.query.uid);
        }
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    },
};
</script>

<style>
</style>
